import { paths } from '../../types/api/Partners';
import { authenticatedFetch, getFromGalaxy, getFromGalaxyCDN } from '../api';

type DonationProgram = paths['/v2/donation-programs/{id}']['get'];
type DonationProgramResponse = DonationProgram['responses']['200']['content']['application/json'];

export async function getDonationProgramById(donationProgramId: string) {
  return getFromGalaxyCDN<DonationProgramResponse>(
    `partners/v2/donation-programs/${donationProgramId}`,
  );
}

type DonationPrograms = paths['/v2/donation-programs/']['get'];
type DonationProgramsResponse = DonationPrograms['responses']['200']['content']['application/json'];

export async function getDonationProgramsBySlug(slug: string) {
  return getFromGalaxyCDN<DonationProgramsResponse>(`partners/v2/donation-programs`, { slug });
}

type PartnerStatisticsWidget = paths['/v2/widgets/statistics/']['get'];
type PartnerStatisticsWidgetResponse =
  PartnerStatisticsWidget['responses']['200']['content']['application/json'];

export async function getPartnerStatisticWidget(
  partnerId: string,
  donationProgramId: string,
  programType?: string[],
) {
  return getFromGalaxyCDN<PartnerStatisticsWidgetResponse>(
    `partners/v2/widgets/statistics`,
    { programType },
    {
      headers: {
        'x-api-key': Buffer.from(`${partnerId}:${donationProgramId}`).toString('base64'),
      },
    },
  );
}

export async function getPartnerStatisticWidgetByAffiliateName(
  affiliateName: string,
  programType?: string[],
) {
  return getFromGalaxyCDN<PartnerStatisticsWidgetResponse>(`partners/v2/widgets/statistics`, {
    affiliateName,
    programType,
  });
}

type ClaimGet = paths['/v2/payment-requests/claim']['get'];
type ClaimGetResponse = ClaimGet['responses']['200']['content']['application/json'];

export const getPaymentRequestByPayload = async ({ payload }: ClaimGet['parameters']['header']) => {
  return getFromGalaxy<ClaimGetResponse>(`partners/v2/payment-requests/claim`, undefined, {
    headers: { payload },
  });
};

type ClaimPost = paths['/v2/payment-requests/claim']['post'];

export const claimDonation = async ({
  payload,
}: ClaimPost['requestBody']['content']['application/json']) => {
  return await authenticatedFetch(`partners/v2/payment-requests/claim`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ payload }),
  });
};

type PartnerRequest = paths['/v2/partners/{id}']['get'];
type PartnerResponse = PartnerRequest['responses']['200']['content']['application/json'];

export const getPartner = async ({ id }: PartnerRequest['parameters']['path']) => {
  return getFromGalaxyCDN<PartnerResponse>(`partners/v2/partners/${id}`);
};

type Partners = paths['/v2/partners/']['get']['responses']['200']['content']['application/json'];
export async function getPartnersByProfileId(profileId: string) {
  return getFromGalaxyCDN<Partners>(`partners/v2/partners/`, {
    profileId,
  });
}

type PartnerProfileRequest = paths['/v2/profiles/{id}']['get'];
type PartnerProfileResponse =
  PartnerProfileRequest['responses']['200']['content']['application/json'];

export const getPartnerProfile = async ({ id }: PartnerProfileRequest['parameters']['path']) => {
  return getFromGalaxyCDN<PartnerProfileResponse>(`partners/v2/profiles/${id}`);
};
